import {
  Options,
  SubEventOption,
  SessionOption,
  OptionType,
  NumberOption,
  TextOption,
} from '../types'

export const isSubEventOption = (option: Options | undefined): option is SubEventOption =>
  option?.type === OptionType.SubEventOption

export const isSessionOption = (option: Options | undefined): option is SessionOption =>
  option?.type === OptionType.SessionOption

export const isNumberOption = (option: Options | undefined): option is NumberOption =>
  option?.type === OptionType.NumberOption

export const isTextOption = (option: Options | undefined): option is TextOption =>
  option?.type === OptionType.TextOption
